export const filterOptions = t => [{
  label: t('amadeusRatingSection.filters.options.all'),
  value: 'all'
}, {
  label: t('amadeusRatingSection.filters.options.family'),
  value: 'family'
}, {
  label: t('amadeusRatingSection.filters.options.single'),
  value: 'single'
}, {
  label: t('amadeusRatingSection.filters.options.couple'),
  value: 'couple'
}, {
  label: t('amadeusRatingSection.filters.options.friends'),
  value: 'friends'
}];
export const sortingOptions = t => [{
  label: t('amadeusRatingSection.sorting.options.latestReviews'),
  value: 'latest'
}, {
  label: t('amadeusRatingSection.sorting.options.bestReviews'),
  value: 'ratingDesc'
}, {
  label: t('amadeusRatingSection.sorting.options.worstReviews'),
  value: 'ratingAsc'
}, {
  label: t('amadeusRatingSection.sorting.options.travelMonth'),
  value: 'travelTime'
}, {
  label: t('amadeusRatingSection.sorting.options.youngToOld'),
  value: 'ageAsc'
}, {
  label: t('amadeusRatingSection.sorting.options.oldToYoung'),
  value: 'ageDesc'
}];